import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { SeriennrListView } from './list-view/seriennr.list-view';

export const seriennrFieldOk: FieldOkConfig = {
  name: 'seriennr',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{plangruppe}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: SeriennrListView,
      },
    },
  ],
};
export const seriennrMultiselectFieldOk: FieldOkConfig = {
  name: 'seriennr',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: SeriennrListView,
      },
    },
  ],
};

export const seriennrQueryFieldOk: FieldOkConfig = {
  name: 'seriennr',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: SeriennrListView,
      },
    },
  ],
};
